// extracted by mini-css-extract-plugin
export default {"list":"pLI64","item":"yvgA9","active":"SCwi6","label":"DdZ8O","coche":"ORsqU","datetime":"gCoUB","date":"BXQsb","time":"yuMdY"};